import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

import { ApplicationInsights, PropertiesPlugin } from '@microsoft/1ds-analytics-web-js';
import { QosPlugin } from '@microsoft/1ds-qos-js';
import { EventType } from '../types/EventType';
import { getErrorJsonData } from '../utils/getErrorJsonData';
import { stringifyHelper } from '../utils/stringifyHelper';
import { scrubUnknownEventType, scrubSensitiveData } from '../utils/scrubSensitiveData';

/**
 * Create a factory to initiate OneDsTelemetry sink
 */
export var createFactory = function createFactory(oneDsParams) {
  return function (factoryParams) {
    return new OneDsTelemetrySink(oneDsParams, factoryParams);
  };
};
/**
 * Telemetry sink that uses 1DS SDK to send telemetry data to the 1DS pipeline
 */

var OneDsTelemetrySink = /*#__PURE__*/_createClass(function OneDsTelemetrySink(_config, _factoryParams) {
  var _this = this;

  _classCallCheck(this, OneDsTelemetrySink);

  this.id = 'OneDsTelemetrySink';
  this._appInsights = new ApplicationInsights();
  this._qosPlugin = new QosPlugin();
  this._propertiesPlugin = new PropertiesPlugin();

  this._initializeTelemetry = function (initialConfig, factoryParams) {
    var instrumentKey = initialConfig.instrumentKey,
        enablePublishTelemetry = initialConfig.enablePublishTelemetry,
        enableConsolePrinting = initialConfig.enableConsolePrinting,
        enableNetworkCallTracking = initialConfig.enableNetworkCallTracking,
        endpointUrl = initialConfig.endpointUrl; // Configure ApplicationInsights

    var webAnalyticsConfig = {
      autoCapture: {
        onLoad: false,
        onUnload: false,
        click: false,
        jsError: false,
        pageView: true
      },
      useDefaultContentName: false,
      urlCollectHash: true
    }; // Add part A properties: https://msasg.visualstudio.com/Shared%20Data/_git/1DS.JavaScript?path=%2Fextensions%2Fproperties

    var propertiesConfig = {
      dropIdentifiers: true,
      hashIdentifiers: true,
      scrubIpOnly: true,
      populateBrowserInfo: true,
      populateOperatingSystemInfo: true
    };
    var config = {
      instrumentationKey: instrumentKey,
      // Extra extensions
      extensions: [_this._qosPlugin, _this._propertiesPlugin],
      webAnalyticsConfiguration: webAnalyticsConfig,
      propertyConfiguration: propertiesConfig,
      extensionConfig: {},
      endpointUrl: endpointUrl
    }; // Config Ajax/Fetch auto tracking: https://msasg.visualstudio.com/Shared%20Data/_git/1DS.JavaScript?path=%2Fextensions%2FqosAnalytics%2FREADME.md&version=GBmaster&fullScreen=true&_a=preview

    var qosConfig = {
      disableAjaxTracking: !enableNetworkCallTracking,
      enableAjaxPerfTracking: enableNetworkCallTracking,
      enableAjaxErrorStatusText: enableNetworkCallTracking
    };

    if (config.extensionConfig) {
      config.extensionConfig[_this._qosPlugin.identifier] = qosConfig;
    }

    if (config.extensionConfig) {
      config.extensionConfig[_this._propertiesPlugin.identifier] = propertiesConfig;
    } // Initialize SDK


    _this._appInsights.initialize(config, []); // Modify the content of telemetry data before send it


    _this._appInsights.addTelemetryInitializer(function (item) {
      if (!item.baseData) {
        item.baseData = {};
      }

      if (!item.data) {
        item.data = {};
      } // Get the latest context properties


      item.data = _objectSpread(_objectSpread({}, item.data), factoryParams.getContextData());

      try {
        var isKnownEventType = Object.values(EventType).includes(item.name);
        item.baseData = _this.sanitizeData(_objectSpread({}, item.baseData), isKnownEventType);
        item.data = _this.sanitizeData(_objectSpread({}, item.data), isKnownEventType);
      } catch (e) {
        _this.error({
          name: 'Data scrub error',
          data: e
        });

        return false;
      }

      if (enableConsolePrinting) {
        console.log(item.name, item);
      }

      if (!enablePublishTelemetry) {
        // The log won't be sent
        return false;
      }

      return true;
    });
  };

  this.reportCustomEvent = function (logEvent) {
    var name = logEvent.name,
        data = logEvent.data,
        context = logEvent.context;

    _this._appInsights.trackEvent({
      name: EventType.CustomEvent,
      data: _objectSpread({
        name: name,
        message: stringifyHelper(data)
      }, context) // The 'data' property doesn't support 'undefined' type. Take the advice from 1DS team to cast it to 'any' type to allow logging optional data.

    });
  };

  this.reportPerformance = function (logEvent) {
    var name = logEvent.name,
        data = logEvent.data,
        context = logEvent.context;

    _this._appInsights.trackEvent({
      name: EventType.Performance,
      data: _objectSpread({
        name: name,
        details: stringifyHelper(data)
      }, context)
    });
  };

  this.reportQos = function (logEvent) {
    var name = logEvent.name,
        data = logEvent.data,
        context = logEvent.context;

    _this._appInsights.trackEvent({
      name: EventType.Qos,
      data: _objectSpread(_objectSpread({
        name: name
      }, data), context)
    });
  };

  this.warn = function (logEvent) {
    var name = logEvent.name,
        data = logEvent.data,
        context = logEvent.context;

    _this._appInsights.trackEvent({
      name: EventType.Warn,
      data: _objectSpread(_objectSpread({
        name: name
      }, data), context)
    });
  };

  this.error = function (logEvent) {
    var name = logEvent.name,
        data = logEvent.data,
        context = logEvent.context; // Not return the Error instance, otherwise it cannot be stringified by 1DS

    var error = getErrorJsonData(data); // The built-in trackException API cannot be used as it might generate array fields that cannot be propagated to Interchange/Geneva
    // This is known limitation and the Interchange team has the plan to fix it

    _this._appInsights.trackEvent({
      name: EventType.Error,
      data: _objectSpread({
        name: name,
        message: error.message,
        stack: error.stack
      }, context)
    });
  };

  this.sanitizeData = function (data, isKnownEventType) {
    data = stringifyHelper(data);

    if (!isKnownEventType) {
      data = scrubUnknownEventType(data);
    }

    return JSON.parse(scrubSensitiveData(data));
  };

  this._initializeTelemetry(_config, _factoryParams);
});
//# sourceMappingURL=OneDsTelemetrySink.js.map